import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Tooltip = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="tooltip icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 20.498C13.1046 20.498 14 19.6026 14 18.498C14 17.3934 13.1046 16.498 12 16.498C10.8954 16.498 10 17.3934 10 18.498C10 19.6026 10.8954 20.498 12 20.498ZM10.5 8.49802C10.5 7.66959 11.1716 6.99802 12 6.99802C12.8284 6.99802 13.5 7.66959 13.5 8.49802C13.5 8.85668 13.2896 9.28692 12.8161 9.62294C12.2752 10.0068 11.6687 10.5338 11.2101 11.1913C10.7491 11.8522 10.3647 12.7572 10.5151 13.8101C10.6322 14.6302 11.392 15.2001 12.2121 15.0829C13.0322 14.9658 13.6021 14.206 13.4849 13.3859C13.477 13.3305 13.4782 13.1835 13.6706 12.9076C13.8655 12.6283 14.1802 12.3336 14.5524 12.0695C15.6278 11.3062 16.5 10.0412 16.5 8.49802C16.5 6.01274 14.4853 3.99802 12 3.99802C9.51472 3.99802 7.5 6.01273 7.5 8.49802C7.5 9.32644 8.17157 9.99802 9 9.99802C9.82843 9.99802 10.5 9.32644 10.5 8.49802Z"
    />
  </svg>
)
